import { QUICK_FILTER_PAGE_IDS } from "../quickFilterUtils";
import { createSystemPresetsFromRules } from "./createSystemPresetsFromRules";

const PAGE_ID = QUICK_FILTER_PAGE_IDS.SEARCH_TERM_V2;

const AMAZON_RULES = [
  {
    section: "metrics",
    id: "spend_gt_0",
    name: "Spend > 0",
    member: "spends",
    operator: "gt",
    values: [0],
  },
  {
    section: "dimension",
    id: "campaign_status_enabled",
    name: "Campaign Status = Enabled",
    member: "campaign_status",
    operator: "equals",
    values: ["ENABLED"],
  },
  {
    section: "dimension",
    id: "targeting_type_automatic",
    name: "Targeting Type = Automatic",
    member: "targeting_type",
    operator: "equals",
    values: ["Automatic"],
  },
  {
    section: "dimension",
    id: "match_type_phrase",
    name: "Match Type = Phrase",
    member: "match_type",
    operator: "equals",
    values: ["PHRASE"],
  },
];

const SEARCH_TERM_V2_PRESETS = {
  amazon: createSystemPresetsFromRules(PAGE_ID, "amazon", AMAZON_RULES),
};

export default SEARCH_TERM_V2_PRESETS;
